export default "__VITE_ASSET__DIR3vCth__"